module.exports = __webpack_public_path__ + "img/numberTwo.86f1265d.png";